const $ = jQuery.noConflict();

'use strict';
const PasswordStrength = {
	/** @description Initialize */

	init: function() {
		this.bindEvents();
		PasswordStrength.OnChange();
	},

	bindEvents: () => {
		$(document.body).on(
			'keyup change',
			'form.register #reg_password, ' +
			'form.checkout #account_password, ' +
			'form.edit-account #password_1, ' +			// "/my-account/edit-account"
			'form.lost_reset_password #password_1',
			PasswordStrength.OnChange
		);
	},

	OnChange: () => {
		const wrapper = $('form.register, form.checkout, form.edit-account, form.lost_reset_password');
		const submit = $('button[type="submit"]', wrapper);
		const field = $('#reg_password, #account_password, #password_1', wrapper);
		const fieldValue = field.val();

		// skip for normal pages
		if (wrapper.length === 0 || field.length === 0) {
			return;
		}

		// calculate strength
		let Allowed = fieldValue.length >= 6;

		// allow empty password at "/my-account/edit-account" page
		if (wrapper.hasClass('edit-account') && fieldValue.length === 0) {
			Allowed = true;
		}

		// obey to your destiny
		if (Allowed) {
			submit.removeAttr('disabled', 'disabled').removeClass('disabled');
		} else {
			submit.attr('disabled', 'disabled').addClass('disabled');
		}
	},
};

export default PasswordStrength;
